import { forwardRef } from 'react';
import { cn } from '../../utils/cn';
import { Input } from './Input';

const FormField = forwardRef(({
	label,
	error,
	helperText,
	required = false,
	className,
	labelClassName,
	errorClassName,
	helperClassName,
	children,
	...props
}, ref) => {
	const hasError = !!error;
	const inputState = hasError ? 'error' : 'default';

	return (
		<div className={cn("space-y-2 space-x-2", className)}>
			{label && (
				<label
					className={cn(
						"text-sm font-medium font-roboto text-foreground",
						required && "after:content-['*'] after:ml-0.5 after:text-red-500",
						labelClassName
					)}
				>
					{label}
				</label>
			)}

			{children ? (
				// Custom input component
				children
			) : (
				// Default Input component
				<Input
					ref={ref}
					state={inputState}
					{...props}
				/>
			)}

			{error && (
				<p className={cn("text-sm text-red-600 font-roboto", errorClassName)}>
					{error}
				</p>
			)}

			{helperText && !error && (
				<p className={cn("text-sm text-muted-foreground font-roboto", helperClassName)}>
					{helperText}
				</p>
			)}
		</div>
	);
});

FormField.displayName = "FormField";

export { FormField }; 